
  var _styles = {
  "package-card": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "1.82667rem",
    "paddingTop": "0.13333rem",
    "paddingRight": "0.05333rem",
    "paddingBottom": "0.13333rem",
    "paddingLeft": "0.05333rem",
    "position": "relative"
  },
  "discount-card": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.73333rem"
  },
  "discount-card-image": {
    "width": "1.73333rem",
    "height": "1.56rem",
    "borderRadius": 0
  },
  "package-content": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "maxWidth": "4.93333rem",
    "marginLeft": "0.24rem"
  },
  "package-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.58667rem",
    "marginBottom": "0.08rem"
  },
  "package-description": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem"
  },
  "go-use-btn": {
    "position": "absolute",
    "right": 0,
    "width": "1.6rem",
    "height": "0.8rem",
    "borderRadius": "1.22667rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": "0.26667rem",
    "marginLeft": "0.08rem"
  },
  "go-use-btn-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem"
  }
};



  module.exports = _styles;
  